import { None, Option } from "@siteimprove/alfa-option";
import { Trampoline } from "@siteimprove/alfa-trampoline";
import * as json from "@siteimprove/alfa-json";
import { Node } from "../node.js";
/**
 * @public
 */
export class Type extends Node {
    static of(name, publicId = None, systemId = None, externalId, internalId, extraData) {
        return new Type(name, publicId, systemId, externalId, internalId, extraData);
    }
    static empty() {
        return new Type("html", None, None);
    }
    _name;
    _publicId;
    _systemId;
    constructor(name, publicId, systemId, externalId, internalId, extraData) {
        super([], "type", externalId, internalId, extraData);
        this._name = name;
        this._publicId = publicId;
        this._systemId = systemId;
    }
    get name() {
        return this._name;
    }
    get publicId() {
        return this._publicId;
    }
    get systemId() {
        return this._systemId;
    }
    toJSON(options) {
        const result = {
            ...super.toJSON(options),
        };
        delete result.children;
        const verbosity = options?.verbosity ?? json.Serializable.Verbosity.Medium;
        if (verbosity < json.Serializable.Verbosity.Medium) {
            return result;
        }
        result.name = this.name;
        result.publicId = this._publicId.getOr(null);
        result.systemId = this._systemId.getOr(null);
        return result;
    }
    toString() {
        return `<!doctype ${this._name}>`;
    }
}
/**
 * @public
 */
(function (Type) {
    function isType(value) {
        return value instanceof Type;
    }
    Type.isType = isType;
    /**
     * @internal
     */
    function fromType(json) {
        return Trampoline.done(Type.of(json.name, Option.from(json.publicId), Option.from(json.systemId), json.externalId, json.internalId));
    }
    Type.fromType = fromType;
    /**
     * @internal
     */
    function cloneType(type) {
        return Trampoline.done(Type.of(type.name, type.publicId, type.systemId, type.externalId, type.internalId));
    }
    Type.cloneType = cloneType;
})(Type || (Type = {}));
//# sourceMappingURL=type.js.map